var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiamond(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDiamond") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-7",
    transform: "translate(-109.000000, -502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDiamond",
    transform: "translate(109.000000, 502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Diamond-Copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fillOpacity: 0.5,
    fill: "#C8C8C8",
    fillRule: "nonzero",
    points: "15.0077714 0.709121212 17.9360762 4.823 15.0073524 4.823 12.0794667 4.823"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fillOpacity: 0.5,
    fill: "#C8C8C8",
    fillRule: "nonzero",
    points: "6.22327619 4.823 9.1599619 14.6696667 0.366666667 4.823"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fillOpacity: 0.5,
    fill: "#C8C8C8",
    fillRule: "nonzero",
    points: "9.1511619 0.709121212 6.22327619 4.823 3.29497143 0.709121212"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fillOpacity: 0.3,
    fill: "#D3D3D3",
    fillRule: "nonzero",
    points: "3.29497143 0.709121212 6.22327619 4.823 0.366666667 4.823"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "17.9457143 4.83148485 9.1599619 14.6696667 12.0794667 4.823 15.0073524 4.823 17.9360762 4.823"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "15.0077714 0.709121212 12.0794667 4.823 9.1511619 0.709121212"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fillOpacity: 0.3,
    fill: "#D3D3D3",
    fillRule: "nonzero",
    points: "9.1511619 0.709121212 12.0794667 4.823 6.22327619 4.823"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fillOpacity: 0.3,
    fill: "#D3D3D3",
    fillRule: "nonzero",
    points: "12.0794667 4.823 9.1599619 14.6696667 6.22327619 4.823"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.366667, 0.700000)",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "17.5865905 4.123 17.5790476 4.13148485 8.79329524 13.9696667 0 4.123"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 4.123 2.92830476 0.00912121212 5.85660952 4.123"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "5.85660952 4.123 8.78449524 0.00912121212 11.7128 4.123"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.7128 4.123 14.6411048 0.00912121212 17.5694095 4.123 14.6406857 4.123"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "2.92830476 0.00912121212 8.78449524 0.00912121212 14.6411048 0.00912121212"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "5.85660952 4.123 8.79329524 13.9696667 11.7128 4.123"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiamond);
export default __webpack_public_path__ + "static/media/icDiamond.2a5553b16f1a2fb1a287b0e740ca821f.svg";
export { ForwardRef as ReactComponent };